var getSelectedBankInfo = function (bankInfos) {
    if (bankInfos === undefined || bankInfos.length === 0) {
        return null;
    }
    var selected = bankInfos.filter(function (bankInfo) { return bankInfo.selected; }, {});
    return selected.length > 0 ? selected[0] : null;
};
export default getSelectedBankInfo;
